"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = require("../constants/errors");
function isExportFinished(responseHeaders) {
    var taskState = responseHeaders.status;
    return taskState === errors_1.SUCCESS_REQUEST_STATUS || taskState >= errors_1.BAD_REQUEST_STATUS; // OK || ERROR
}
exports.isExportFinished = isExportFinished;
function isDateFilter(filter) {
    if (filter.dateFilter) {
        return true;
    }
    return false;
}
exports.isDateFilter = isDateFilter;
function sanitizeDateFilter(filter) {
    var dateFilter = filter.dateFilter;
    var optionalProps = {};
    if (dateFilter.from) {
        optionalProps.from = String(dateFilter.from);
    }
    if (dateFilter.to) {
        optionalProps.to = String(dateFilter.to);
    }
    return {
        dateFilter: __assign({}, dateFilter, optionalProps),
    };
}
exports.sanitizeDateFilter = sanitizeDateFilter;
function sanitizeDateFilters(filters) {
    return filters.map(function (filter) {
        if (isDateFilter(filter)) {
            return sanitizeDateFilter(filter);
        }
        return filter;
    });
}
exports.sanitizeDateFilters = sanitizeDateFilters;
